import { Component, DestroyRef, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faX } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { Bid, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './bid.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class BidComponent extends RepositoryModal<Bid> {
    faX = faX
    pendingFiles: File[] = []

    private destroyRef = inject(DestroyRef)

    onFileChanged(event: Event) {
        const input = event.target as HTMLInputElement
        if (!input.files) return
        for (let i = 0; i < input.files.length; i++) {
            this.pendingFiles.push(input.files[i])
        }
        input.value = ''
    }

    removeFile(file: File) {
        const idx = this.pendingFiles.indexOf(file)
        if (idx > -1) this.pendingFiles.splice(idx, 1)
    }

    openAbstract(url: string) {
        window.open('./Resources/Images/BidAbstract/' + url, '_blank')
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        const observable = this.isAdding || this.isDuplicating ? this.repositoryAdd() : this.repositoryEdit()
        observable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: successResult => {
                if (this.pendingFiles.length === 0) {
                    resolveSave(successResult)
                    return
                }

                const uploadData = new FormData()
                uploadData.append('id', successResult.id)
                for (let i = 0; i < this.pendingFiles.length; i++) {
                    uploadData.append('myFile' + i, this.pendingFiles[i], this.pendingFiles[i].name)
                }
                this.services.data
                    .post('api/Bid/UploadAbstracts', uploadData)
                    .pipe(takeUntilDestroyed(this.destroyRef))
                    .subscribe({
                        next: () => {
                            resolveSave(successResult)
                        },
                        error: errorResult => {
                            rejectSave(errorResult)
                        },
                    })
            },
            error: errorResult => {
                rejectSave(errorResult)
            },
        })
    }
}
